// Copyright (c) 2021, DIALPAD INC., all rights reserved.

import React, {Component} from 'react';
import {getMessageComponent} from './utils';

interface MessageFactoryProps {
    message: any;
    messages: any[];
    metricId?: string;
    type?: string;
    messageType?: string;
    isResponse?: boolean;
    typeMessage?: string;
    requiredPermissions: any[];
    scopes: any[];
    resetCache?: any;
}

export class MessageFactory extends Component<MessageFactoryProps> {
    state = {
        isHovering: false,
    };
    handleMouseHover = () => {
        this.setState({isHovering: !this.state.isHovering});
    };

    render() {
        const {
            message,
            messages: allMessages,
            requiredPermissions,
            scopes,
            metricId,
            type,
            messageType,
            isResponse,
            typeMessage,
            resetCache,
        } = this.props;
        const {isHovering} = this.state;

        const props = {
            isHovering,
            message,
            allMessages,
            onMouseEnter: this.handleMouseHover,
            onMouseLeave: this.handleMouseHover,
            requiredPermissions,
            scopes,
            messages: this.props.messages,
            metricId,
            type,
            messageType,
            isResponse,
            typeMessage,
            resetCache,
        };

        return <>{getMessageComponent(props)}</>;
    }
}
